export default "__VITE_ASSET__2969e86c__"